import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'
import fast from '../assets/images/fast.png';

function TimelineEd() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Academic Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="08/2024 - 02/2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img style={{ marginRight: '5px' }} src={fast} alt="icon" width="40" height="40" />
              <h2 className="vertical-timeline-element-title">FAST - NUCES</h2>
            </div>
            <h4>Visiting Faculty</h4>
            <p>
              Independently conducted full-fledged lab sessions for the following courses:
              <ul>
                <li>Introduction to Information and
                  Computing Technology</li>
                <li>Object-Oriented
                  Programming</li>
              </ul>Delivered 3-hour weekly lab demonstrations based on the course outline provided by the coordinator. Managed all aspects of assessment, including designing assignments, quizzes, midterm, and final exams.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="04/2024 - 08/2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img style={{ marginRight: '5px' }} src={fast} alt="icon" width="40" height="40" />
              <h2 className="vertical-timeline-element-title">FAST - NUCES</h2>
            </div>
            <h4>Student Laboratory Assistant (SLA)</h4>
            <p>
              Assisted the instructor in conducting lab sessions, helping students debug and resolve coding errors while ensuring they understood their assignments. Provided guidance on programming concepts and best practices to enhance their problem-solving skills. Supported students in the following courses:
              <ul>
                <li>Data Structures</li>
                <li>Object-Oriented
                  Programming</li>
              </ul>
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="08/2024 - 02/2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <img style={{ marginRight: '5px' }} src={fast} alt="icon" width="40" height="40" />
              <h2 className="vertical-timeline-element-title">FAST - NUCES</h2>
            </div>
            <h4>Teaching Assistant (TA)</h4>
            <p>
              Responsible for evaluating and grading students' assignments, quizzes, and projects for the following courses:
              <ul>
                <li>Information Retrieval</li>
                <li>Data Structures</li>
                <li>Object-Oriented
                  Programming</li>
              </ul>
              Additionally, provided students with assistance in understanding course material, debugging code, and addressing any queries related to their coursework.            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default TimelineEd;